/**
 * Validação FE do documento do consumidor no caixa.
 * Espelha App\Support\Fiscal\CashierConsumerDocument (backend é a fonte de verdade).
 */
(function (root) {
    'use strict';

    var TP_NONE = 'none';
    var TP_CPF = 'cpf';
    var TP_CNPJ = 'cnpj';

    function rawInput(nDoc) {
        if (nDoc === null || nDoc === undefined) {
            return '';
        }
        return String(nDoc).trim();
    }

    function stripCnpj(value) {
        if (typeof root.stripCnpjFormatting === 'function') {
            return root.stripCnpjFormatting(value);
        }
        return String(value || '').toUpperCase().replace(/[.\-\/\s]/g, '');
    }

    function fail(code, message, field) {
        return { error: true, code: code, message: message, field: field };
    }

    function ok(tpDoc, nDoc) {
        return { error: false, tpDoc: tpDoc, nDoc: nDoc };
    }

    function validateForEmission(tpDoc, nDoc) {
        var tp = String(tpDoc || '').toLowerCase().trim();
        var raw = rawInput(nDoc);

        if (!tp || tp === TP_NONE) {
            if (tp === TP_NONE && raw !== '') {
                return fail(
                    'TIPO_DOCUMENTO_DESTINATARIO_INVALIDO',
                    'Com “não informar documento”, o campo de CPF/CNPJ deve ficar vazio.',
                    'nDoc'
                );
            }
            if (!tp && raw !== '') {
                return fail(
                    'TIPO_DOCUMENTO_DESTINATARIO_INVALIDO',
                    'Selecione se o documento é CPF, CNPJ ou não informar.',
                    'tpDoc'
                );
            }
            return ok(TP_NONE, null);
        }

        if (tp === TP_CPF) {
            if (raw === '') {
                return fail('DOCUMENTO_DESTINATARIO_OBRIGATORIO', 'Informe um CPF válido para continuar.', 'nDoc');
            }
            var strippedCpf = stripCnpj(raw);
            var digitsCpf = String(raw).replace(/\D/g, '');
            if (/[A-Z]/i.test(strippedCpf) || strippedCpf.length > 11 || digitsCpf.length > 11) {
                return fail(
                    'CPF_DESTINATARIO_INVALIDO',
                    'O CPF informado possui formato ou dígitos verificadores inválidos.',
                    'nDoc'
                );
            }
            if (typeof root.validaCPF !== 'function' || !root.validaCPF(raw)) {
                return fail(
                    'CPF_DESTINATARIO_INVALIDO',
                    'O CPF informado possui formato ou dígitos verificadores inválidos.',
                    'nDoc'
                );
            }
            return ok(TP_CPF, digitsCpf);
        }

        if (tp === TP_CNPJ) {
            if (raw === '') {
                return fail('DOCUMENTO_DESTINATARIO_OBRIGATORIO', 'Informe um CNPJ válido para continuar.', 'nDoc');
            }
            var stripped = stripCnpj(raw);
            var digits = String(raw).replace(/\D/g, '');
            if (digits.length === 11 && stripped.length === 11 && !/[A-Z]/i.test(stripped)) {
                return fail(
                    'CNPJ_DESTINATARIO_INVALIDO',
                    'O CNPJ informado possui formato ou dígitos verificadores inválidos.',
                    'nDoc'
                );
            }
            if (typeof root.validaCNPJ !== 'function' || !root.validaCNPJ(raw)) {
                return fail(
                    'CNPJ_DESTINATARIO_INVALIDO',
                    'O CNPJ informado possui formato ou dígitos verificadores inválidos.',
                    'nDoc'
                );
            }
            var normalized = typeof root.normalizeCnpj === 'function' ? root.normalizeCnpj(raw) : stripped;
            return ok(TP_CNPJ, normalized);
        }

        return fail('TIPO_DOCUMENTO_DESTINATARIO_INVALIDO', 'Tipo de documento do destinatário inválido.', 'tpDoc');
    }

    root.FoxCashierConsumerDocument = {
        TP_NONE: TP_NONE,
        TP_CPF: TP_CPF,
        TP_CNPJ: TP_CNPJ,
        validateForEmission: validateForEmission
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = root.FoxCashierConsumerDocument;
    }
})(typeof window !== 'undefined' ? window : global);
